<h2 mat-dialog-title>Search</h2>
<div mat-dialog-content>
<inthraction-employee-search [options]="options" (employeeSelected)="searchEmployee($event)"></inthraction-employee-search>
</div>
